import fetchUrl, { fetchJson, postJson } from 'utils/fetch';

export const get = user => fetchJson(`/mc/my-space/${user}/items.json`);

export const save = (user, docs) => postJson(`/mc/my-space/${user}`, docs);

export const upload = file => {
  const data = new FormData();
  data.append('attachment', file);

  return fetchUrl(`/resources/upload`, {
    method: 'POST',
    body: data,
  }).then(res => res.json());
};

export const deleteEvent = id =>
  fetchUrl(`/mc/calendar/events/${id}`, {
    method: 'DELETE',
  });



// WEBPACK FOOTER //
// ./src/modules/my-space/api/index.js